var React = require('react');

function CloseCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.414 12l2.829 2.828a1 1 0 0 1-1.415 1.415L12 13.414l-2.828 2.829a1 1 0 1 1-1.415-1.415L10.586 12L7.757 9.172a1 1 0 0 1 1.415-1.415L12 10.586l2.828-2.829a1 1 0 0 1 1.415 1.415L13.414 12zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10s-4.477 10-10 10zm0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16z","fill":"#0e0e0e","key":0}),React.createElement("rect",{"x":"0","y":"0","width":"16","height":"16","fill":"rgba(0, 0, 0, 0)","key":1})]);
}

CloseCircle.defaultProps = {"width":"24","height":"24","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24","style":{"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"}};

module.exports = CloseCircle;

CloseCircle.default = CloseCircle;
